/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Unfinished_NoticeInputs */



/**
* | output |
* | --- |
* | "These events you organize have rounds played but were never finished, so nobody gets their results. Open each one to finish it:" |
*
* @param {Tournaments_Unfinished_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_unfinished_notice = /** @type {((inputs?: Tournaments_Unfinished_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Unfinished_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ces événements que vous organisez ont des rondes jouées mais n'ont jamais été terminés : personne n'a ses résultats. Ouvrez chacun pour le terminer :")
	if (locale === "es") return /** @type {LocalizedString} */ ("Estos eventos que organizas tienen rondas jugadas pero nunca se finalizaron, así que nadie recibe sus resultados. Abre cada uno para finalizarlo:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Estes eventos que você organiza têm rodadas jogadas mas nunca foram encerrados, então ninguém recebe seus resultados. Abra cada um para encerrá-lo:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Questi eventi che organizzi hanno round giocati ma non sono mai stati conclusi, quindi nessuno riceve i propri risultati. Apri ciascuno per concluderlo:")
	return /** @type {LocalizedString} */ ("These events you organize have rounds played but were never finished, so nobody gets their results. Open each one to finish it:")
});